export const DeviceModelDefault = 'MK_DAT';
